<template>
  <section class="content">
    <template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i v-if="alert.type == 'success' || alert.type == 'warning'" class="icon fa fa-check"></i>
          <i class="icon fa fa-ban" v-else></i>
          {{ 'alert_' + alert.type | translate }}!</h4>
        <p v-if="alert.type !== 'danger'">
          {{ alert.message }}
        </p>
        <ul v-else>
          <li v-for="e in alert.message">
            {{ e }}
          </li>
        </ul>
      </b-alert>
    </template>
    <div class="box">
      <div class="box-header with-border">
        <h3 class="box-title"><i class="fa fa-money mr-5"></i>{{ 'edit_mp_fees' | translate }}</h3>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-xs-12 col-lg-2">
            <div class="input-group">
              <label>{{ "creditorNo"|translate }}</label>
              <input
                  type="text"
                  class="form-control"
                  id="InpCreditorNo"
                  v-model="creditorNo" name="creditorNo"
                  @keyup="creditorKeyUp()"
              >
            </div>
          </div>
          <div class="col-xs-12 col-lg-2">
            <label>{{ "marketplace" | translate }}</label>
            <template v-if="isCreditorNoAvailable">
              <select
                class="form-control"
                v-model="selectedMarketplace"
              >
                <option
                  class="normal"
                  value="selectMarketplace"
                >
                  {{ 'select_marketplace' | translate }}
                </option>

                <option
                  class="normal"
                  v-for="(marketplace,key) in salesChannels"
                  :value="key"
                >
                  {{ marketplace | translate }}
                </option>
              </select>
            </template>
            <template v-else>
               <select
                 disabled
                 class="form-control"
                 v-model="selectedMarketplace"
               >
               </select>
            </template>
          </div>
          <div class="col-xs-12 col-lg-2" v-if="countries.length > 0">
            <label>{{ "country" | translate }}</label>
            <select
                @change="onCountrySelect()"
                class="form-control"
                v-model="selectedCountry"
            >
              <option
                  class="normal"
                  value="select"
              >
                {{ 'select_country' | translate }}
              </option>
              <option
                  class="normal"
                  v-for="country in countries" :value="country"
              >
                {{ country }}
              </option>
            </select>
          </div>
          <div class="col-xs-12 col-lg-2" v-if="!countries.length > 0">
            <label>
              {{ "country"|translate }}
            </label>
            <select
                disabled
                class="form-control"
                v-model="selectedCountry"
            >
              <option
                  class="normal"
                  v-for="country in countries" :value="country"
              >
                {{ country }}
              </option>
            </select>
          </div>
          <div class="col-xs-12 col-lg-2">
            <label>
              {{ "validFromStart"|translate }}
            </label>
            <datepicker
                @input="getFeesForSelectedFilter()"
                input-class="form-control pepe"
                calendar-class="datepicker"
                v-model="validFromStart"
            >
            </datepicker>
          </div>
          <div class="col-xs-12 col-lg-2">
            <label>
              {{ "validFromEnd"|translate }}
            </label>
            <datepicker
                @input="getFeesForSelectedFilter()"
                input-class="form-control pepe"
                calendar-class="datepicker"
                v-model="validFromEnd"
            >
            </datepicker>
          </div>
          <div class="col-xs-12 col-lg-2 pull-right">
            <button
                data-toggle="modal"
                data-target="#EditFeesModal"
                @click="openModal(-1,false)"
                class="btn btn-info custom pull-right"
            >
              <i class="fa fa-plus mr-5">
              </i>
              {{ 'createNew' | translate }}
            </button>
          </div>
          <br/>
          <br/>
          <div class="col-xs-12 col-lg-2 pull-right">
            <button
                data-toggle="modal"
                @click="refreshActiveFees()"
                v-if="refreshButton !== 0"
                :disabled="selectedCountry === 'select'"
                class="btn btn-warning custom pull-right"
            >
              <i class="fa fa-undo mr-5">
              </i>
              {{ 'active_fees' | translate }}
            </button>
          </div>
        </div>
        <div class="row" v-if="company_name !== null">
          <span class="col-md-12 col-xs-12">
            <strong>
              {{ company_name }}
            </strong>
          </span>
        </div>
      </div>
    </div>
    <div class="box box-primary no-border">
      <div class="box-body">
        <div class="col-xs-12">
          <div class="row">
            <div class="col-xs-12 text-red text-center" v-if="showFurtherFeeText">
              <strong>
                <i class="fa fa-exclamation-triangle">
                </i>
                {{ "showFurtherFeeText" | translate | replace(':limit:',this.feeLimit) }}
              </strong>
            </div>
            <br/>
            <hr/>
          </div>
          <div class="table-responsive">
            <table class="table table-hover editFeeTable">
              <thead>
              <tr>
                <th>{{ 'sales_channel' | translate }}</th>
                <th>{{ 'order_type' | translate }}</th>
                <th>{{ 'type' | translate }}</th>
                <th>{{ 'country' | translate }}</th>
                <th>{{ 'mp_costs_step_1' | translate }}</th>
                <th>{{ 'mp_costs_step_2' | translate }}</th>
                <th>{{ 'mp_costs_step_3' | translate }}</th>
                <th>{{ 'mp_costs_step_4' | translate }}</th>
                <th>{{ 'mp_costs_step_default' | translate }}</th>
                <th>{{ 'anwr_trans_costs_step_1' | translate }}</th>
                <th>{{ 'anwr_trans_costs_step_2' | translate }}</th>
                <th>{{ 'anwr_return_costs_step_1' | translate }}</th>
                <th>{{ 'anwr_return_costs_step_2' | translate }}</th>
                <th>{{ 'mp_return_costs' | translate }}</th>
                <th>{{ 'mp_return_costs_max' | translate }}</th>
                <th>{{ 'mp_payment_costs' | translate }}</th>
                <th>{{ 'valid_from' | translate }}</th>
                <th>{{ 'note' | translate}}</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(fee,index) in fees">
                <td>
                  {{ fee.sales_channel.name | translate }}
                </td>
                <td>
                  {{ fee.order_type }}
                </td>
                <td>
                  {{ fee.type }}
                </td>
                <td>
                  {{ fee.country }}
                </td>
                <td v-if="fee.mp_costs_step_1 > 0">
                  {{ fee.mp_costs_step_1 | percentage }}
                </td>
                <td v-else>
                  {{ fee.mp_costs_step_1 | fieldNotInUse }}
                </td>
                <td v-if="fee.mp_costs_step_2 > 0">
                  {{ fee.mp_costs_step_2 | percentage }}
                </td>
                <td v-else>
                  {{ fee.mp_costs_step_2 | fieldNotInUse }}
                </td>
                <td v-if="fee.mp_costs_step_3 > 0">
                  {{ fee.mp_costs_step_3 | percentage }}
                </td>
                <td v-else>
                  {{ fee.mp_costs_step_3 | fieldNotInUse }}
                </td>
                <td v-if="fee.mp_costs_step_4 > 0">
                  {{ fee.mp_costs_step_4 | percentage }}
                </td>
                <td v-else>
                  {{ fee.mp_costs_step_4 | fieldNotInUse }}
                </td>
                <td v-if="fee.mp_costs_step_default > 0">
                  {{ fee.mp_costs_step_default | percentage }}
                </td>
                <td v-else>
                  {{ fee.mp_costs_step_default | fieldNotInUse }}
                </td>
                <td v-if="fee.anwr_trans_costs_step_1 > 0">
                  {{ fee.anwr_trans_costs_step_1 | currency }}
                </td>
                <td v-else>
                  {{ fee.anwr_trans_costs_step_1 | fieldNotInUse }}
                </td>
                <td v-if="fee.anwr_trans_costs_step_2 > 0">
                  {{ fee.anwr_trans_costs_step_2 | currency }}
                </td>
                <td v-else>
                  {{ fee.anwr_trans_costs_step_2 | fieldNotInUse }}
                </td>
                <td v-if="fee.anwr_return_costs_step_1 > 0">
                  {{ fee.anwr_return_costs_step_1 | currency }}
                </td>
                <td v-else>
                  {{ fee.anwr_return_costs_step_1 | fieldNotInUse }}
                </td>
                <td v-if="fee.anwr_return_costs_step_2 > 0">
                  {{ fee.anwr_return_costs_step_2 | currency }}
                </td>
                <td v-else>
                  {{ fee.anwr_return_costs_step_2 | fieldNotInUse }}
                </td>
                <td v-if="fee.mp_return_costs > 0">
                  {{ fee.mp_return_costs | percentage }}
                </td>
                <td v-else>
                  {{ fee.mp_return_costs | fieldNotInUse }}
                </td>
                <td v-if="fee.mp_return_costs_max > 0">
                  {{ fee.mp_return_costs_max | currency }}
                </td>
                <td v-else>
                  {{ fee.mp_return_costs_max | fieldNotInUse }}
                </td>
                <td v-if="fee.mp_payment_costs > 0">
                  {{ fee.mp_payment_costs | currency }}
                </td>
                <td v-else>
                  {{ fee.mp_payment_costs | fieldNotInUse }}
                </td>
                <td>
                  <template v-if="fee.is_future">
                    <span style="color: #E08E0B;">{{ fee.valid_from | orderDateReverse }}</span>
                  </template>
                  <template v-else>
                    {{ fee.valid_from | orderDateReverse }}
                  </template>
                </td>
                <td>
                  <button class="btn btn-info" data-toggle="modal" :data-target="`#hint-${fee.id}`">
                    <i class="fa fa-question-circle"></i>
                  </button>

                  <div class="modal fade" :id="`hint-${fee.id}`" tabindex="-1" role="dialog" aria-labelledby="hintFee" style="display: none;">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                          <h4 class="modal-title"><i class="fa fa-database mr-5"></i>Confirm</h4>
                        </div>
                        <div class="modal-body">
                          <table class="table">
                            <tr>
                              <td>{{"created_by" | translate}}</td><td>{{ fee.created_by }}</td>
                            </tr>
                            <tr>
                              <td>{{"created_at" | translate}}</td><td>{{fee.created_at}}</td>
                            </tr>
                            <tr>
                              <td>{{"updated_by" | translate}}</td><td>{{ fee.updated_by }}</td>
                            </tr>
                            <tr>
                              <td>{{"updated_by" | translate}}</td><td>{{fee.updated_at}}</td>
                            </tr>
                            <tr>
                              <td>{{"commentary" | translate}}</td><td> {{ fee.comment }}</td>
                            </tr>
                          </table>
                        </div>
                        <div class="modal-footer">
                          <button type="button" id="closeModal" class="btn btn-danger" data-dismiss="modal"><span class="fa fa-times mr-5"></span>{{'close' | translate}}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td v-if="Date.parse(fee.valid_from) > Date.now()">
                  <button
                      @click="openModal(index,true)"
                      data-toggle="modal"
                      data-target="#EditFeesModal"
                      class="btn btn-default"
                  >
                    {{ "edit"|translate }}
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <edit-fees-modal
      @modalClicked="modalClicked($event)"
      @handleUpdate="handleUpdate($event)"
      :editMode="editMode"
      :salesChannels="salesChannels"
      :loaded="modalLoaded"
      :company_name="this.company_name"
      :creditorValue="this.creditorNo"
      :fee="this.selectedFee"
      :validFromValueProp="Object.keys(this.selectedFee).length > 0? new Date(this.selectedFee.valid_from) : new Date('2021-01-01')"
    >
    </edit-fees-modal>
  </section>
</template>

<script>
import {translate} from "../../../filters";

export default {
  data() {
    return {
      companies: [],
      countries: [],
      isCreditorNoAvailable: false,
      selectedCountry: "select",
      selectedMarketplace: 'selectMarketplace',
      creditorNo: '',
      alert: {show: false},
      alerts: [],
      lastTimeStap: 0,
      timeOut: 0,
      validFromStart: 0,
      validFromEnd: 0,
      fees: [],
      modalLoaded: false,
      selectedFee: {},
      company_name: '',
      salesChannels: {},
      editMode: true,
      refreshButton: 1,
      showFurtherFeeText: false,
      feeLimit: 50
    }
  },
  methods: {
    showAlert(message) {
      alert = {
        dismiss: 4,
        type: 'danger',
        message: [message],
        icon: 'icon fa fa-ban',
        show: true,
      }
      this.alerts.push(alert)
    },
    getFeesForSelectedFilter() {
      var filter = [];

      if (this.creditorNo < 10) {
        return
      }
      if (this.validFromStart === '' || this.validFromEnd === '') {
        return
      }
      if (this.creditorNo) {
        filter.push('creditorNo=' + this.creditorNo)
      }
      if (this.selectedMarketplace !== "selectMarketplace") {
        filter.push('salesChannelId=' + this.selectedMarketplace)
      }
      if (this.selectedCountry !== "select") {
        filter.push('country=' + this.selectedCountry)
      }
      if (this.validFromStart) {
        filter.push('validFromStart=' + moment(this.validFromStart).format('YYYY-MM-DD'))
      }
      if (this.validFromEnd) {
        filter.push('validFromEnd=' + moment(this.validFromEnd).format('YYYY-MM-DD'))
      }

      filter.push('limit=' + this.feeLimit);

      var filterUrl = filter.join('&');

      this.fees = [];
      API.get("/accounting/fees/getByFilter?" + filterUrl)
          .then(res => {
            if (res.data.length > 0) {
              this.fees = res.data
              this.showFurtherFeeText = res.data.length >= this.feeLimit;
            }
          }).catch(error => {
        this.showAlert(error)
      });
    },
    onCountrySelect() {
      if (this.validFromStart !== '' && this.validFromEnd !== '') {
        return this.getFeesForSelectedFilter()
      }
      this.refreshActiveFees()
    },
    refreshActiveFees() {
      this.validFromStart = 0
      this.validFromEnd = 0

      this.getFeesForSelectedFilter()

      this.validFromStart = ''
      this.validFromEnd = ''
    },
    creditorKeyUp() {
      this.fees = []
      this.countries = []
      this.selectedCountry = "select"
      this.selectedMarketplace = "selectMarketplace"

      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(this.checkForCreditorNo, 1000);
    },
    checkForCreditorNo() {
      if (this.creditorNo.length === 0 || this.creditorNo.length < 10) {
        return
      }
      API.get("/accounting/fees/company/" + this.creditorNo)
          .then(res => {
            if (res.data.length === 0) {
              this.isCreditorNoAvailable = false
              var erromsg = translate('noFeesFound')
              this.showAlert(erromsg)
            }
            this.isCreditorNoAvailable = true
            this.countries = res.data.countries
            this.company_name = res.data.companyName
            this.getFeesForSelectedFilter();
          }).catch(error => {
        this.showAlert(error)
      });
    },
    openModal(index, edit) {
      if (index >= 0) {
        this.selectedFee = this.fees[index];
      } else {
        this.selectedFee = {}
      }
      this.editMode = edit
      this.modalLoaded = true;
    },
    saveOrUpdate(fee) {
      API.post("/accounting/fees/save", fee)
          .then(res => {
            let alert = {
              type: 'success',
              dismiss: 4,

            }
            this.getFeesForSelectedFilter()

            this.$store.commit('pushAlert', alert)
            this.selectedFee = {}
            this.modalLoaded = false
          })
          .catch(error => {
            this.showAlert(error)
            this.selectedFee = {}
            this.modalLoaded = false
          });
    },
    modalClicked(value) {
      if (value !== "") {
        this.saveOrUpdate(this.selectedFee)
      }
    },
    getSalesChannels() {
      API.get("/accounting/fees/getSalesChannels")
          .then(res => {
            Object.entries(res.data).forEach(entry => {
              let name = entry[1].replace('schuhede-', '')
              this.salesChannels[entry[0]] = name
            })
          }).catch(error => {
        this.showAlert(error)
      });
    },
    handleUpdate(value) {
      API.get(`/accounting/fees/company/${value}`)
          .then(res => {
            if (res.data.length === 0) {
              let erromsg = translate('noFeesFound')
              this.showAlert(erromsg)
            }
            this.company_name = res.data.companyName
            this.selectedFee.creditorNo = value
            this.selectedFee.company_id = res.data.company_id;
          }).catch(error => {
        this.showAlert(error)
      });
    }
  },
  mounted() {
    this.getSalesChannels()
  },
  watch: {
    selectedMarketplace() {
      this.getFeesForSelectedFilter()
    }
  }
}
</script>

<style>
.datepicker {
  color: white;
  background-color: #212228;
  border: 1px solid rgba(255, 255, 255, .15);
}

.custom {
  width: 180px !important;
}


.editFeeTable > thead > tr > th {
  width: 25%;
}

.editFeeTable > tbody > tr > td {
  width: 25%
}

</style>



// WEBPACK FOOTER //
// src/components/views/Accounting/EditFees.vue